<div class="white-box main-black mt-4 p-4 border-radius">
	<!-- Title: always shown when this is a study context -->
	<div class="row p-1" *ngIf="studyInfo?.id && deviceConfig?.performance?.hasInuseEndVoltageReport">
		<div class="col-sm-6 col-md-6">
			<h4>
				{{'studies.study_in_use_end_voltage' | translate}}
				<app-help-tooltip *ngIf="tooltips.end_voltage_report"
					[field]="tooltips.end_voltage_report"></app-help-tooltip>
			</h4>
		</div>
	</div>
	
	<ng-container *ngIf="studyStartedToday || isDeviceShipped === false; else charts">
		<ng-container *ngTemplateOutlet="noData"></ng-container>
	</ng-container>
	
	<ng-template #charts>
		<!-- In-Use End Voltage -->
		<div *ngIf="endVoltageChartReady && deviceConfig?.performance?.hasInuseEndVoltageReport">
			<div class="row p-1">
				<div class="col-sm-6 col-md-6" *ngIf="!studyInfo?.id">
					<h4>
						{{'site_performance.end_voltage_report' | device_translation:deviceType}}
						<app-help-tooltip *ngIf="tooltips.end_voltage_report" [field]="tooltips.end_voltage_report"></app-help-tooltip>
					</h4>
				</div>
				<div class="col-sm-6 col-md-1 ml-auto d-inline-flex" *ngIf="endVoltageChartData.length">
					<button class="btn fa fa-print fa-lg ml-1" printTitle="{{'g.performance' | translate}}" [useExistingCss]="true" printSectionId="endVoltage-chart" ngxPrint title="{{'g.print' | translate}}"></button>
					<button class="fa fa-upload btn" title="{{'g.export_to_csv' | translate}}" (click)="exportEndVoltage()"></button>
				</div>
			</div>
			<div class="row" *ngIf="!useParentFilters">
				<div class="col-sm-6 col-md-12 col-xl-8 d-inline-flex">
					<div class="input-group col-6 p-0 mr-3 d-inline-flex">
						<div class="input-group-prepend">
							<span class="input-group-text">{{'g.start_date' | translate}}</span>
						</div>
						<input class="form-control" [ngClass]="{'text-danger': endVoltageInvalidDateRange}" [minDate]="deviceInstallationDate" [maxDate]="maxDate" placeholder="mm/dd/yyyy" name="evStartDB" [(ngModel)]="endVoltageFromDate" (ngModelChange)="endVoltageDatesChanged()" bsDatepicker #evStartDB="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}"/>
						<div class="input-group-append pointer" (click)="evStartDB.toggle()">
							<span class="input-group-text"><i class="fa fa-calendar"></i></span>
						</div>
					</div>
					<div class="input-group col-6 p-0 mr-3 d-inline-flex">
						<div class="input-group-prepend">
							<span class="input-group-text">{{'g.end_date' | translate}}</span>
						</div>
						<input class="form-control" placeholder="mm/dd/yyyy" name="evEndDB" [(ngModel)]="endVoltageToDate" [minDate]="deviceInstallationDate" [maxDate]="maxDate" (ngModelChange)="endVoltageDatesChanged()" bsDatepicker #evEndDB="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}"/>
						<div class="input-group-append pointer" (click)="evEndDB.toggle()">
							<span class="input-group-text"><i class="fa fa-calendar"></i></span>
						</div>
					</div>
				</div>
			</div>
			<div id="endVoltage-chart" *ngIf="endVoltageChartData.length; else noData">
				<div class="showOnPrint">
					<h3>{{'devices.truck_sn_short' | translate}}: {{device.config_info.truck_sn}}</h3>
					<h3>{{'devices.serial_number' | translate}}: {{device.serial_number}}</h3>
					<h4><span [tooltip]="'tooltip.time_source_pc' | translate">{{'perf_analytic.period' | translate}}</span>: {{endVoltageFromDate | date:'MM/dd/yyyy'}} - {{endVoltageToDate | date:'MM/dd/yyyy'}}</h4>
				</div>
				<app-print-filters title="site_performance.end_voltage_report_device" [filters]="printFilters"></app-print-filters>
				<sct-charts
					id="endVoltage_chart"
					[title]="'site_performance.end_voltage_report_device' | translate"
					[data]="endVoltageChartData"
					[columnNames]="endVoltageChartColumnNames"
					[options]="endVoltageInuseOptions"
					[type]="'ColumnChart'"
					[height]="500"
					[formatterType]="'colorFormat'"
					[formatter]="'anything'"
					(select)="onSelectEndVoltage($event)"
				></sct-charts>
				<div class="showOnPrint">
					<table class="table">
						<thead>
							<th>{{'events.sequence_id' | translate}}</th>
							<th [tooltip]="'tooltip.time_source_utc' | translate">{{'events.timestamp' | translate}}</th>
							<th>{{'event.vpc' | translate}}</th>
						</thead>
						<tbody>
							<ng-container *ngFor="let dayItems of endVoltageAllTableItems">
								<tr *ngFor="let item of dayItems">
									<td>{{item.sequence_id}}</td>
									<td>{{item.timestamp}}</td>
									<td>{{item.vpc}}</td>
								</tr>
							</ng-container>
						</tbody>
					</table>
				</div>
				<app-modal #endVoltageModal [title]="'event.end_voltage' | translate" [hasConfirmButton]="false" [hasCloseButton]="true" [size]="'lg'">
					<sct-custom-table
						*ngIf="endVoltageModal.render"
						[columnsConfig]="endVoltageColumnConfig"
						[data]="inuseEndVoltageTableData"
						[config]="endVoltageTableConfig"
					></sct-custom-table>
				</app-modal>
			</div>
		</div>

		<!-- Charge End Voltage -->
		<div class="mt-4" *ngIf="chargeEndVoltageChartReady && deviceConfig?.performance?.hasChargeEndVoltageReport && !studyInfo?.id">
			<div class="row p-1">
				<div class="col-sm-6 col-md-6">
					<h4>
						{{'site_performance.charge_end_voltage_report' | device_translation:deviceType}}
						<app-help-tooltip *ngIf="tooltips.charge_end_voltage_report" [field]="tooltips.charge_end_voltage_report"></app-help-tooltip>
					</h4>
				</div>
				<div class="col-sm-6 col-md-1 ml-auto d-inline-flex" *ngIf="chargeEndVoltageChartData.length">
					<button class="btn fa fa-print fa-lg ml-1" printTitle="{{'g.performance' | translate}}" [useExistingCss]="true" printSectionId="charge_endVoltage_chart" ngxPrint title="{{'g.print' | translate}}"></button>
					<button class="fa fa-upload btn" title="{{'g.export_to_csv' | translate}}" (click)="exportChargeEndVoltage()"></button>
				</div>
			</div>
			<div id="charge_endVoltage_chart" *ngIf="chargeEndVoltageChartData.length; else noData">
				<div class="showOnPrint">
					<h3>{{'devices.truck_sn_short' | translate}}: {{device.config_info.truck_sn}}</h3>
					<h3>{{'devices.serial_number' | translate}}: {{device.serial_number}}</h3>
					<h4><span [tooltip]="'tooltip.time_source_pc' | translate">{{'perf_analytic.period' | translate}}</span>: {{endVoltageFromDate | date:'MM/dd/yyyy'}} - {{endVoltageToDate | date:'MM/dd/yyyy'}}</h4>
				</div>
				<app-print-filters title="site_performance.end_voltage_report_device" [filters]="printFilters"></app-print-filters>
				<sct-charts
					id="charge_endVoltage_chart"
					[title]="'site_performance.end_voltage_report_device' | translate"
					[data]="chargeEndVoltageChartData"
					[columnNames]="endVoltageChartColumnNames"
					[options]="endVoltageChargeOptions"
					[type]="'ColumnChart'"
					[height]="500"
					[formatterType]="'colorFormat'"
					[formatter]="'anything'"
					(select)="onSelectChargeEndVoltage($event)"
				></sct-charts>
				<div class="showOnPrint">
					<table class="table">
						<thead>
							<th>{{'events.sequence_id' | translate}}</th>
							<th [tooltip]="'tooltip.time_source_utc' | translate">{{'events.timestamp' | translate}}</th>
							<th>{{'event.vpc' | translate}}</th>
						</thead>
						<tbody>
							<ng-container *ngFor="let dayItems of chargeEndVoltageAllTableItems">
								<tr *ngFor="let item of dayItems">
									<td>{{item.sequence_id}}</td>
									<td>{{item.timestamp}}</td>
									<td>{{item.vpc}}</td>
								</tr>
							</ng-container>
						</tbody>
					</table>
				</div>
				<app-modal #chargeEndVoltageModal [title]="'event.end_voltage' | translate" [hasConfirmButton]="false" [hasCloseButton]="true" [size]="'lg'">
					<sct-custom-table
						*ngIf="chargeEndVoltageModal.render"
						[columnsConfig]="endVoltageColumnConfig"
						[data]="chargeEndVoltageTableData"
						[config]="endVoltageTableConfig"
					></sct-custom-table>
				</app-modal>
			</div>
		</div>
	</ng-template>
</div>

<ng-template #noData>
	<div class="mt-4 alert alert-info">{{'g.no_data_to_show' | translate}}</div>
</ng-template>
